import { AlumniaLogo } from '@/components/alumnia-logo'

interface BrandedLoaderProps {
  /**
   * Optional message under the logo. Pass `null` (NOT `undefined`) to
   * render the logo only — top global apps (Instagram, WhatsApp, Linear,
   * Stripe Dashboard) all use a static brand mark on cold launch; the
   * "Loading…" text is amateur. Existing Suspense fallbacks
   * (`app/in/[orgSlug]/loading.tsx` etc.) still pass a translated
   * message — they're page-level skeleton replacements, not the cold-
   * launch shell, so the text is appropriate there.
   */
  message?: string | null
  bgColor?: string
}

export function BrandedLoader({
  message = 'Loading...',
  bgColor = 'bg-brand-primary',
}: BrandedLoaderProps) {
  return (
    <div className={`flex h-screen w-full items-center justify-center ${bgColor}`}>
      <div className="flex flex-col items-center gap-4">
        <AlumniaLogo size={64} variant="light" />
        {/* Render the message only when explicitly provided. `null` = logo-only
            cold-launch mode used by NativeAppShell. */}
        {message ? <span className="text-white font-serif italic">{message}</span> : null}
      </div>
    </div>
  )
}
